import { useRemoteCombobox } from '@/setup/remoteCombobox.js';
import { reactive, getCurrentInstance, ref, computed } from 'vue';

export const useCAReceiptDetailData = () => {
  const { proxy } = getCurrentInstance();
  const { comboboxLoadData, submitQuickAdd } = useRemoteCombobox();

  // Init các field của grid detail

  const initGridColumnParallel = () => {
    return [
      {
        caption: 'Diễn giải',
        dataField: 'description',
        columnType: proxy.$ms.constant.ColumnType.Text,
        width: 250,
        editable: true,
        sortable: true,
      },
      {
        caption: 'TK Nợ',
        dataField: 'debit_account',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        title: 'Tài khoản Nợ',
        sortable: true,
      },
      {
        caption: 'TK Có',
        dataField: 'credit_account',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        title: 'Tài khoản Có',
        sortable: true,
      },
      {
        caption: 'Số tiền',
        dataField: 'amount_oc',
        width: 150,
        editable: true,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        sortable: true,
      },
      {
        caption: 'Quy đổi',
        dataField: 'amount',
        width: 150,
        editable: true,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        visible: false,
        sortable: true,
        rules: [
          {
            name: 'lessThanAmount',
            compareValue: 100000000000000,
          },
        ],
      },
      {
        caption: 'Nguồn',
        dataField: 'budget_source_name',
        width: 250,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Mã dự phòng',
        dataField: 'budget_provide_code',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Chương',
        dataField: 'budget_chapter_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
      },
      {
        width: 100,
        caption: 'Loại',
        visible: false,
        editable: true,
        sortable: true,
        dataField: 'budget_kind_item_code',
        columnType: 1,
      },
      {
        caption: 'Khoản',
        dataField: 'budget_sub_kind_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Mục',
        dataField: 'budget_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Tiểu mục',
        dataField: 'budget_sub_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Tiết tiểu mục',
        dataField: 'budget_detail_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Cấp phát',
        dataField: 'method_distribute_name',
        columnType: proxy.$ms.constant.ColumnType.Enum,
        editable: true,
        formatType: proxy.$ms.constant.FormatType.Enum,
        width: 136,
        sortable: true,
        enum: 'MethodDistributeType',
      },
      {
        caption: 'Nghiệp vụ',
        dataField: 'cash_withdraw_type_name',
        columnType: proxy.$ms.constant.ColumnType.Enum,
        editable: true,
        formatType: proxy.$ms.constant.FormatType.Enum,
        width: 136,
        sortable: true,
        enum: 'CashWithDrawType',
      },
      {
        caption: 'Hoạt động',
        dataField: 'activity_name',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 136,
        sortable: true,
      },
      {
        caption: 'CTMT, dự án',
        dataField: 'project_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 136,
        title: 'Chương trình mục tiêu, dự án',
        sortable: true,
      },
      {
        caption: 'Tài khoản NH, KB',
        dataField: 'bank_account',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 160,
        title: 'Tài khoản ngân hàng, kho bạc',
        sortable: true,
      },
      {
        caption: 'Phí, lệ phí',
        title: 'Phí, lệ phí',
        dataField: 'budget_fees_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 100,
        sortable: true,
      },
      {
        width: 100,
        caption: 'Đề tài',
        editable: true,
        sortable: true,
        dataField: 'topic_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        filterable: true,
      },
      {
        width: 100,
        caption: 'Hợp đồng',
        editable: true,
        sortable: true,
        dataField: 'contract_no',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
      },
      {
        width: 100,
        caption: 'Nhiệm vụ',
        dataField: 'task_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        width: 100,
        caption: 'Nguồn năm trước',
        editable: true,
        sortable: true,
        dataField: 'is_source_before_year',
        columnType: proxy.$ms.constant.ColumnType.Checkbox,
      },
      {
        caption: '',
        dataField: 'rowAction',
        width: 80,
        columnType: proxy.$ms.constant.ColumnType.Action,
        sortable: false,
      },
    ];
  };

  // Khởi tạo các field của grid
  const columnParallel = reactive(initGridColumnParallel());

  /**
   * Biến dùng để check disable các button tiện ích
   * @returns true - khi khác mode View
   * TVDAT 22/07/2022
   */
  const valueMode = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View;
  });

  /**
   * Biến dùng để check disable button tiện ích Xóa chứng từ hiện thời
   * @returns true - khi đã ghi sổ hoặc ở các mode khác mode View
   * TVDAT 21/07/2022
   */
  const disabledBtnDelete = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
  });

  /**
   * Biến lưu trạng thái của form khi ở mode view
   * TVDAT 21/07/2022
   */
  const valueModeView = computed(() => {
    return proxy.editMode == proxy.$ms.constant.FormState.View;
  });

  const disabledGetReceipt = computed(() => {
    return proxy.editMode == proxy.$ms.constant.FormState.View || proxy.model.IsElectronicTicket
  })

  /**
  * Biến disable lấy vé điện tử
  * NNLINH 12.09.2023
  */
  const disabledGetTicket = computed(() => {
    return (
      proxy.editMode == proxy.$ms.constant.FormState.View ||
      proxy.model.IsInvoiceGenerateData
    );
  });

  // item của button tiện ích
  const buttonUtilities = reactive([
    {
      text: 'Thêm chứng từ',
      command: proxy.$ms.constant.Command.Add,
      disabledItem: valueMode,
    },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: proxy.$ms.constant.Command.Duplicate,
      disabledItem: valueMode,
      IsSubMenu: true,
      subItem: [
        {
          text: 'Phiếu thu',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAReceiptDetail',
          refType: proxy.$ms.constant.RefType.CAReceipt,
          initial: true
        },
        {
          text: 'Phiếu thu rút dự toán nhập quỹ',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAReceiptPlanWithdrawDetail',
          refType: proxy.$ms.constant.RefType.CAReceiptPlanWithdraw
        },
        {
          text: 'Phiếu chi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAPaymentDetail',
          refType: proxy.$ms.constant.RefType.CAPayment
        },
        {
          text: 'Chuyển khoản kho bạc',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUTransferDetail',
          refType: proxy.$ms.constant.RefType.BUTransfer
        },
        {
          text: 'Chứng từ nghiệp vụ khác',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'GLGeneralVoucherDetail',
          refType: proxy.$ms.constant.RefType.GLGeneralVoucher
        },
        {
          text: 'Chi tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BAWithDrawDetail',
          refType: proxy.$ms.constant.RefType.BAWithDraw
        },
        {
          text: 'Thu tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BADepositDetail',
          refType: proxy.$ms.constant.RefType.BADeposit
        },
      ]
    },
    // {
    //   text: 'Xóa chứng từ hiện thời',
    //   command: proxy.$ms.constant.Command.Delete,
    //   disabledItem: disabledBtnDelete,
    // },
    {
      text: 'Lấy biên lai',
      command: 'GetReceipt',
      disabledItem: disabledGetReceipt,
    },
    {
      text: 'Lấy vé điện tử',
      command: proxy.$ms.constant.Command.GetElectronicTicket,
      disabledItem: disabledGetTicket,
    },
    {
      text: 'Xem số dư tài khoản',
      command: proxy.$ms.constant.Command.ViewAccount,
    },
    {
      text: 'Sao chép chứng từ',
      command: proxy.$ms.constant.Command.Copy,
      disabledItem: valueModeView,
    },
    {
      text: 'Cất thành định khoản tự động mới',
      command: proxy.$ms.constant.Command.AddAutoBusiness,
    },
  ]);

  // item button in
  const buttonPrints = [
    {
      text: 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
      disabledItem: true,
    },
    {
      text: 'C2-02b/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
      disabledItem: true,
    },
    {
      text: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
      disabledItem: true,
    },
    {
      text: 'C4-02b/KB: Ủy nhiệm chi ngoại tệ ( Nghị định 11/2020/NĐ-CP)',
      disabledItem: true,
    },
    {
      text: 'C40-BB: Phiếu thu',
      disabledItem: true,
    },
    {
      text: 'C40-BB: Phiếu thu (2 liên)',
      disabledItem: true,
    },
    {
      text: 'Chứng từ kế toán',
      disabledItem: true,
    },
    {
      text: 'Chứng từ kế toán (Mẫu nguyên tệ)',
      disabledItem: true,
    },
    {
      text: 'C40-BB: Phiếu thu (2 liên - Mẫu Tiểu mục)',
      disabledItem: true,
    },
    {
      text: 'C40-BB: Phiếu thu (2 liên - A5)',
      disabledItem: true,
    },
    {
      text: 'C40-BB: Phiếu thu (Giấy cuộn - A5)',
      disabledItem: true,
    },
    {
      text: 'C40-BB: Phiếu thu (Mẫu chi tiết nghiệp vụ kế toán)',
      disabledItem: true,
    },
    {
      text: 'C40-BB: Phiếu thu (Mẫu Tiểu mục)',
      disabledItem: true,
    },
    {
      text: 'C40-BB: Phiếu thu (nhiều dòng)',
      disabledItem: true,
    },
    {
      text: 'C45-BB: Biên lai thu tiền)',
      disabledItem: true,
    },
    {
      text: 'Tùy chọn in...',
      disabledItem: true,
    },
  ];

  return {
    buttonUtilities,
    buttonPrints,
    columnParallel,
    submitQuickAdd,
    comboboxLoadData,
  };
};
